export default () => ({
  alreadySeePopupPersonality: false,
  previousLanguage: ''
})
